//#region import
import React from 'react';
//custom component
import { EmptyPage, Backbutton } from "_molecules";
//bootstrap
import { Row, Col } from 'react-bootstrap';
//#endregion

const EmptyBookingsList = (props) => {

  return (
    <>
      <Row>
        <Col>
          <div style={{ marginBottom: 30 }}><Backbutton /></div>

          {/* Empty Table */}
          <EmptyPage
            title={"Not Verified"}
            subtitle={"Until the verification process has been completed bookings will not appear here."}
            subsubtitle={"Please check back once your account has been verified."}
          />

        </Col>
      </Row>
    </>
  );
}

export default EmptyBookingsList;
